import { IPersona, ISearchBox } from "@fluentui/react";
import { useEffect, useRef, useState } from "react";
import {
  IDataTablePersonas,
  ITableFilterPersonas,
} from "../../Interfaces/IPersona";
import personaServicio from "../../services/persona/personaServicio";
import { IPaginacion } from "../../Interfaces/filter";
import { InitialFilterPersonas } from "../../utils/Initials/InitialPersonas";

export const useTablaPersonas = () => {
  const [items, setItems] = useState<IDataTablePersonas[]>([]);
  const [paginacion, setPaginacion] = useState<IPaginacion>(null!);
  const [isLoading, setIsLoading] = useState(false);
  const [control, setControl] = useState(false)

  const [filterPersona, setFilterPersona] = useState<ITableFilterPersonas>(
    InitialFilterPersonas
  );
  const searchBoxRefTable = useRef<ISearchBox>(null);
  const _onkeyUpSearchArea = (event: React.KeyboardEvent<HTMLInputElement>) => {
    let { value } = event?.target as HTMLInputElement;
    setFilterPersona({ ...filterPersona, search: value });
  };
  const onChangeCombos = (e, o, nombre) => {
    if (e !== undefined) {
      switch (nombre) {
        case "area":
          if (o?.key) {
            setFilterPersona({ ...filterPersona, areaId: o.key });
          }
          break;
        case "puesto":
          if (o?.key) {
            setFilterPersona({ ...filterPersona, puestoId: o.key });
          }
          break;
        case "guardia":
          if (o?.key) {
            setFilterPersona({ ...filterPersona, guardia: o.key });
          }
          break;
        default:
          break;
      }
    }
  };

  const getTablaPersonas = () => {
    setIsLoading(true);
    personaServicio.postPersonas(filterPersona).then((res) => {
      if (res.status === 200) {
        setItems(res.data.items);
        setIsLoading(false);
        setPaginacion({
          page: res.data.page,
          pages: res.data.pages,
          total: res.data.total,
        });
      } else {
        setIsLoading(false);
      }
    });
  };
  const onChangeSkip = (evento: string) => {
    switch (evento) {
      case "next":
        setFilterPersona({ ...filterPersona, skip: filterPersona.skip + 1 });
        break;
      case "prev":
        setFilterPersona({ ...filterPersona, skip: filterPersona.skip - 1 });
        break;
      default:
        break;
    }
  };
  const limpiarFiltro = () => {
    setFilterPersona(InitialFilterPersonas);
    setControl(true)
  };

  useEffect(() => {
    getTablaPersonas();
    if (control || filterPersona.search || filterPersona.skip || filterPersona.take) {
      getTablaPersonas();
      setControl(false);
    }
  }, [control, filterPersona.search, filterPersona.skip, filterPersona.take]); 
   


  const ActualizarTable = () => {
    getTablaPersonas();
  };

  return {
    items,
    onChangeCombos,
    searchBoxRefTable,
    filterPersona,
    getTablaPersonas,
    _onkeyUpSearchArea,
    onChangeSkip,
    paginacion,
    isLoading,
    limpiarFiltro,
    ActualizarTable
  };
};
